export default "__VITE_ASSET__34de495f__"